module.exports = __webpack_public_path__ + "media/images/icons/icn_024-278dd2cab1c9795491e506fa52a0db18.svg";